import React, { FunctionComponent } from 'react';
import styles from './RewardsEmptyState.module.scss';

const RewardsEmptyState: FunctionComponent = () => {
    return (
        <div className={styles.root}>
            <img
                className={styles.image}
                src="/images/memberships/clients-notfound.svg"
                alt="No rewards activity"
            />
            <p className={styles.title}>No Rewards Activity Yet</p>
            <p className={styles.subtitle}>Points earned and reward activity will appear here.</p>
        </div>
    );
};

export default RewardsEmptyState;
